/* src/app/domains/home/permission-request/permission-request.component.scss */
ion-content {
  --background:
    linear-gradient(
      180deg,
      #0090E2 0%,
      #004F7C 100%);
}
.block {
  background: white;
  width: 85%;
  max-width: 400px;
  border-radius: 16px;
  padding: 25px 20px;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.block h1 {
  color: var(--btn-background2);
}
.block p,
.block h4 {
  color: var(--secondary-background);
}
.block h4 {
  cursor: pointer;
}
ion-footer {
  box-shadow: none;
  background: transparent;
  display: flex;
}
.logo {
  margin-top: calc(4vh + var(--ion-safe-area-top));
  height: 12vh;
  z-index: 1;
}
/*# sourceMappingURL=permission-request.component.css.map */
